/// <reference path="../../ui/types.d.ts" />
import { FC } from 'react';

interface InstallPageProps {
    name: string;
}

export const InstallPage: FC<InstallPageProps> = ({ name }) => (
    <div className="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1420px] items-center justify-around px-6 py-4 text-center">
        <div>
            <h1>Looks like {name} is not installed yet!</h1>
            <p>
                Contact your organization administrator to install it. More info on{' '}
                <a href="https://support.crowdin.com">Link to how to install</a>
            </p>
        </div>
    </div>
);
